import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=3c6ae7cb&"
import script from "./SidebarHeader.vue?vue&type=script&lang=js&"
export * from "./SidebarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports